const filesConstants = {
    GET_REQUEST: 'GET_FILE_REQUEST',
    GET_SUCCESS: 'GET_FILE_SUCCESS',
    GET_FAILURE: 'GET_FILE_FAILURE',
}
export { filesConstants };